// import OrderSummary from './OrderSummary';

export function PicPayForm() {
  return <></>;
  // return <OrderSummary />;
}
